import React from "react";
import { StyleSheet, View } from "react-native";

type Props = {
  children: React.ReactNode;
};

function WebCard({ children }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    container: {
      backgroundColor: "#FFFFFF",
      borderRadius: 12,
      marginBottom: 16,
      padding: 16,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.05,
      shadowRadius: 2,
      elevation: 2,
    },
  });

  return <View style={styles.container}>{children}</View>;
}

export default WebCard;
